package com.sddamico.draftmachine.ds.navigation

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.ds.DmColor
import com.sddamico.draftmachine.ds.DmMotion
import com.sddamico.draftmachine.ds.Icon
import com.sddamico.draftmachine.ds.IconWeight
import com.sddamico.draftmachine.ds.displayInlineBlock
import com.sddamico.draftmachine.ds.spin
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import org.jetbrains.compose.web.css.px

/** Which gear glyph the cog wears — six-tooth (default), plain, or fine-tooth. */
enum class CogTeeth(val glyph: String) {
  Six("gear-six"),
  Plain("gear"),
  Fine("gear-fine"),
}

/**
 * A decorative spinning gear — the ambient machinery motif. Port of
 * `components/navigation/Cog.jsx`. Purely visual (`aria-hidden`, via [Icon]); size and color it
 * through the params or override the surface with [modifier].
 *
 * @param speed a CSS duration string (e.g. `DmMotion.durGear`); slower = statelier.
 * @param reverse spin counter-clockwise.
 * @param teeth pick the gear silhouette.
 */
@Composable
fun Cog(
  modifier: Modifier = Modifier,
  size: CSSLengthNumericValue = 80.px,
  color: Color = DmColor.steel700,
  speed: String = DmMotion.durGear,
  reverse: Boolean = false,
  teeth: CogTeeth = CogTeeth.Six,
) {
  Icon(
    teeth.glyph,
    IconWeight.Fill,
    Modifier
      .fontSize(size)
      .color(color)
      .displayInlineBlock()
      .spin(speed, reverse)
      .then(modifier)
  )
}
